import {ProductModelExtended} from '../product/getProductModel';
import {ProductContentModel} from '../product/ProductContentModel';

export const findContentfulProduct = (
  contentfulProducts: Array<ProductContentModel>,
  selectedProduct?: ProductModelExtended
): ProductContentModel | undefined => {
  if (!selectedProduct) {
    return undefined;
  }

  return (
    contentfulProducts.find(x => x.sku === selectedProduct.sku) ??
    contentfulProducts.find(x => x.sku === selectedProduct.itemNumber)
  );
};
